import Analytics from 'analytics';
import simpleAnalyticsPlugin from '@analytics/simple-analytics';

const isProduction = window.location.hostname === 'app.thedmsark.com';
const plugins = isProduction ? [simpleAnalyticsPlugin()] : [];

const analytics = Analytics({
  app: 'app.thedmsark.com',
  plugins
});

function normalizePath(path: string): string {
  if (path.startsWith('/shared/')) {
    return '/shared/***';
  } else if (path.match(/^\/campaigns\/[^\/]+$/)) {
    return '/campaigns/***';
  } else if (path.match(/^\/sessions\/[^\/]+\/transcript$/)) {
    return '/sessions/***/transcript';
  } else if (path.match(/^\/campaigns\/[^\/]+\/sessions\/create$/)) {
    return '/campaigns/***/sessions/create';
  }
  return path;
}

const IGNORE_PATHS = ['/callback', '/'];

export const trackPageView = (path: string) => {
  if (!isProduction) {
    return;
  }

  if (IGNORE_PATHS.includes(path)) {
    return;
  }

  try {
    const normalizedPath = normalizePath(path);
    analytics.page({
      path: normalizedPath
    });
  } catch (error) {
    console.warn('Analytics page tracking failed:', error);
  }
};

export const identifyUser = (userId: string, userTraits?: Record<string, any>) => {
  if (!isProduction) {
    return;
  }

  try {
    analytics.identify(userId, userTraits);
  } catch (error) {
    console.warn('Analytics user identification failed:', error);
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (!isProduction) {
    return;
  }

  try {
    analytics.track(eventName, properties);
  } catch (error) {
    console.warn('Analytics event tracking failed:', error);
  }
};

export default analytics;
